import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CalcType } from '../../../lookups/CalcType';
import * as fromShared from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { PayrollItem } from '../store';
import { PayrollItemEmployee } from '../store/payroll-item-employee.model';

function addItem() {
    this.id = 'add';
    this.PIListID = '-1';
    this.IsActive = true;
    this.isValid = () =>
        !!this.PayrollItem &&
        this.PayrollItem.length > 0 &&
        !!this.AccountListID &&
        this.AccountListID.length > 0 &&
        !!this.PayrollItemType &&
        this.PayrollItemType.length > 0;
}
@Component({
    selector: 'ef-payroll-item',
    templateUrl: './payroll-item.component.html',
    styleUrls: ['./payroll-item.component.scss'],
    standalone: false
})
export class PayrollItemComponent
    extends fromShared.EditGrid<PayrollItem>
    implements OnChanges
{
    dropdownItemHeight = environment.dropdownItemHeight;
    laborSelectItems: SelectItem[];
    @Input() public employees: PayrollItemEmployee[];
    @Input() payrollItemsSelectItems: SelectItem[] = [];
    @Input() payrollItemTypesSelectItems: SelectItem[] = [];
    @Input() payCodeSelectItems: SelectItem[] = [];
    @Input() accountSelectItems: SelectItem[] = [];
    @Input() employeesSelectItems: SelectItem[] = [];
    @Input() employeesPayrollItemsSelectItems: SelectItem[] = [];
    @Input() qbo: boolean;
    @Input() externalIntegration: boolean;
    @Input() showInactive: boolean;
    @Output() showInactiveChange = new EventEmitter<boolean>();
    public payrollItems: PayrollItem[];
    private _laborTypes: CalcType[];
    @Input() public set laborTypes(value: CalcType[]) {
        this.log.verbose({
            type: 'PayrollItemComponent:set:laborTypes',
            value
        });
        this._laborTypes = value;
        this.laborSelectItems = value.map(x => ({
            label: x.CalcDesc,
            value: x.CalcType
        }));
    }
    public get laborTypes(): CalcType[] {
        return this._laborTypes;
    }

    // addItem: Partial<PayrollItem> = {
    //     id: 'add',
    //     PIListID: '-1',
    // };

    @ViewChild('dataTable', { static: true })
    protected table: fromShared.Table;

    constructor(private log: LoggingService) {
        super();
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        this.log.verbose({
            type: 'PayrollItemComponent:ngOnChanges',
            changes,
            qbo: this.qbo,
            externalIntegration: this.externalIntegration
        });
        this.rebuildPayrollItems();
        this.log.verbose({
            type: 'PayrollItemComponent:ngOnChanges:qbo',
            items: this.payrollItems
        });
    }

    /** Template row must not appear twice (duplicate PIListID breaks p-table dataKey). */
    private payrollItemDataRows(): PayrollItem[] {
        return (this.items ?? []).filter(
            x =>
                String(x?.id ?? '') !== 'add' &&
                String(x?.PIListID ?? '') !== '-1'
        );
    }

    private rebuildPayrollItems(): void {
        if (!this.items) {
            return;
        }
        const data = this.payrollItemDataRows();
        if (this.qbo && !this.externalIntegration) {
            this.payrollItems = [new addItem() as PayrollItem, ...data];
        } else {
            this.payrollItems = data;
        }
    }
    onRowEditInit(item: PayrollItem) {
        super.onRowEditInit(item);
        this.log.verbose({
            type: 'PayrollItemComponent:onRowEditInit',
            item,
            cloned: this.cloned,
            editing: this.editing,
            qbo: this.qbo
        });
        this.selected = fromShared.uniqBy(
            [...(this.selected ?? []), item],
            x => x.PIListID
        );
        this.table.virtualScroll = false;
    }
    onRowEditCancel(item: PayrollItem) {
        super.onRowEditCancel(item);
        this.log.verbose({
            type: 'PayrollItemComponent:onRowEditCancel',
            item
        });
        this.rebuildPayrollItems();

        //this.table.virtualScroll = true;
    }
    /** Alt Pay Rate is only meaningful for hourly payroll item types. */
    isHourlyPayrollItemType(item: PayrollItem | undefined): boolean {
        const pit = (item?.PayrollItemType ?? '').toString().trim().toLowerCase();
        return pit.startsWith('hourly');
    }

    /** Alt Pay Rate is owned by isolved/GCP when external payroll is enabled. */
    isAlternateHourlyEditable(): boolean {
        return !this.externalIntegration;
    }

    onPayrollItemTypeChange(item: PayrollItem): void {
        if (
            this.isAlternateHourlyEditable() &&
            !this.isHourlyPayrollItemType(item)
        ) {
            item.IsAlternateHourly = false;
        }
    }

    onRowEditSave(item: PayrollItem) {
        super.onRowEditSave(item);
        if (
            this.isAlternateHourlyEditable() &&
            !this.isHourlyPayrollItemType(item)
        ) {
            item.IsAlternateHourly = false;
        }
        if ((item.isValid && item.isValid()) || !item.isValid) {
            this.log.verbose({
                type: 'PayrollItemComponent:onRowEditSave',
                item
            });
            //validate?
            this.rebuildPayrollItems();
            //this.table.virtualScroll = true;
        }
    }
}
